<template>
  <ValidationProvider
    v-if="isVisible"
    v-slot="{ touched, failed, errors }"
    :name="field.errorLabel"
    :vid="field.name"
    :rules="field.rules"
    tag="div"
    class="SingleCheckbox"
  >
    <label class="SingleCheckbox-inner" :for="field.name">
      <input
        :id="field.name"
        v-model="thisValue"
        class="SingleCheckbox-input"
        :name="field.name"
        :title="field.title"
        :type="field.type"
      />
      <i class="SingleCheckbox-checkbox fas fa-check"></i>
      <span v-if="field.hasHtml" class="SingleCheckbox-label" v-html="field.title"></span>
      <span v-else class="SingleCheckbox-label" v-text="field.title"></span>
    </label>

    <ErrorMessages :error-messages="errors" :has-error-messages="touched && errors.length > 0" />
  </ValidationProvider>
</template>

<script>
import FormItem from '../../mixins/FormItem'
import ErrorMessages from './ErrorMessages'

import '@fortawesome/fontawesome-free-webfonts/css/fontawesome.css'
import '@fortawesome/fontawesome-free-webfonts/css/fa-solid.css'

export default {
  name: 'SingleCheckbox',
  components: {
    ErrorMessages,
  },
  mixins: [FormItem],
}
</script>

<style lang="scss" scoped>
@use '../../css/foundation/vars';
@use '../../css/foundation/mixins';

.SingleCheckbox {
  max-width: 1018px;
  margin-top: 22px;

  &:first-child {
    margin-top: 0;
  }
}

::v-deep .SingleCheckbox + .SingleCheckbox {
  margin-top: 16px;
}

.SingleCheckbox-inner {
  position: relative;
  display: block;
  border: 1px solid rgba(#fff, 0.2);
  border-radius: 4px;
}

.SingleCheckbox-label {
  display: block;
  padding: 1.5rem 1em 1.5rem 5.7rem;
  font-size: 1.8rem;
  font-weight: vars.$font-weight-medium;
  cursor: pointer;

  ::v-deep a {
    color: vars.$color-btn-accept;
    transition: filter 0.2s ease;

    &:hover {
      filter: brightness(1.3);
    }
  }
}

.SingleCheckbox-checkbox {
  @include mixins.checkbox();
  top: 1.7rem;
  left: 1.5rem;
}

.SingleCheckbox-input {
  display: none;

  &:checked ~ .SingleCheckbox-checkbox {
    @include mixins.checkedCheckbox();
  }
}
</style>
